{
  "CONTACTS_FILTER": {
    "TITLE": "Filtriraj kontakte",
    "SUBTITLE": "Dodajte filtre ispod i kliknite 'Pošalji' za filtriranje kontakata.",
    "EDIT_CUSTOM_SEGMENT": "Uredi segment",
    "CUSTOM_VIEWS_SUBTITLE": "Dodajte ili uklonite filtre i ažurirajte segment.",
    "ADD_NEW_FILTER": "Dodaj filter",
    "CLEAR_ALL_FILTERS": "Očisti sve filtre",
    "FILTER_DELETE_ERROR": "Za spremanje morate imati barem jedan filter",
    "SUBMIT_BUTTON_LABEL": "Pošalji",
    "UPDATE_BUTTON_LABEL": "Ažuriraj segment",
    "CANCEL_BUTTON_LABEL": "Odustani",
    "CLEAR_BUTTON_LABEL": "Očisti filtre",
    "EMPTY_VALUE_ERROR": "Vrijednost je obavezna",
    "SEGMENT_LABEL": "Naziv segmenta",
    "SEGMENT_QUERY_LABEL": "Upit segmenta",
    "TOOLTIP_LABEL": "Filtriraj kontakte",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "I",
      "OR": "ILI"
    },
    "OPERATOR_LABELS": {
      "equal_to": "Jednako",
      "not_equal_to": "Nije jednako",
      "contains": "Sadrži",
      "does_not_contain": "Ne sadrži",
      "is_present": "Prisutno je",
      "is_not_present": "Nije prisutno",
      "is_greater_than": "Veće je od",
      "is_lesser_than": "Manje je od",
      "is_greater_than_or_equal": "Veće ili jednako",
      "is_less_than_or_equal": "Manje ili jednako",
      "newer_than_days": "Novije od x dana (uključivo)",
      "older_than_days": "Starije od x dana (uključivo)"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "Vrijednost je obavezna"
    },
    "ATTRIBUTES": {
      "NAME": "Ime",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Broj telefona",
      "IDENTIFIER": "Identifikator",
      "CITY": "Grad",
      "COUNTRY": "Država",
      "CUSTOM_ATTRIBUTE_LIST": "Popis",
      "CUSTOM_ATTRIBUTE_TEXT": "Tekst",
      "CUSTOM_ATTRIBUTE_NUMBER": "Broj",
      "CUSTOM_ATTRIBUTE_LINK": "Povezica",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "Kvačica",
      "CREATED_AT": "Kreirano",
      "LAST_ACTIVITY": "Zadnja aktivnost",
      "REFERER_LINK": "Povezica preporuke",
      "BLOCKED": "Blokiran"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "Standardni filtri",
      "ADDITIONAL_FILTERS": "Dodatni filtri",
      "CUSTOM_ATTRIBUTES": "Prilagođeni atributi"
    }
  }
}
